<!-- Vendors Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Vendors Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Search -->
      <div class="d-flex align-items-center position-relative my-1 me-5">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="applyFilters()"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search vendors..." />
      </div>

      <!-- Filter Toggle -->
      <button
        type="button"
        class="btn btn-sm btn-light-primary me-3"
        (click)="toggleFilters()">
        <i class="ki-duotone ki-filter fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Filter
      </button>

      <!-- Add Vendor Button -->
      <button
        type="button"
        class="btn btn-sm btn-primary"
        (click)="openAddVendorModal()">
        <i class="ki-duotone ki-plus fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </i>
        Add Vendor
      </button>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body py-4" *ngIf="showFiltersForm">
    <div class="row mb-6">
      <div class="col-md-4">
        <label class="form-label">Date From</label>
        <input
          type="date"
          class="form-control form-control-solid"
          [(ngModel)]="filters.date_from" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Date To</label>
        <input
          type="date"
          class="form-control form-control-solid"
          [(ngModel)]="filters.date_to" />
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <button
          type="button"
          class="btn btn-primary me-3"
          (click)="applyFilters()">
          Apply Filters
        </button>
        <button
          type="button"
          class="btn btn-light"
          (click)="clearFilters()">
          Clear
        </button>
      </div>
    </div>
    <div class="separator separator-dashed"></div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Vendors Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-150px">Company Name</th>
            <th class="min-w-100px">Country</th>
            <th class="min-w-100px">Vendor Type</th>
            <th class="min-w-120px">Contact Person</th>
            <th class="min-w-100px">Phone</th>
            <th class="min-w-120px">Email</th>
            <th class="min-w-80px">Status</th>
            <th class="min-w-100px">Created Date</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="9" class="text-center py-5">
              <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </td>
          </tr>

          <!-- No Data State -->
          <tr *ngIf="!isLoading && vendors.length === 0">
            <td colspan="9" class="text-center py-5">
              <div class="text-muted">No vendors found</div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let vendor of vendors; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5">
                  <div class="symbol-label bg-light-primary">
                    <i class="ki-duotone ki-profile-user fs-2 text-primary">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                    </i>
                  </div>
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ vendor.company_name || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ vendor.country || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ getVendorTypesDisplay(vendor.vendor_type) }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ vendor.contact || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ vendor.mobile || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ vendor.email_1 || '-' }}
              </span>
            </td>
            <td>
              <span class="badge badge-light-success">Active</span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ vendor.created_at | date:'dd/MM/yyyy' }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end">
                <!-- Edit Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-sm btn-light-primary me-2"
                  (click)="openEditVendorModal(vendor)"
                  title="Edit vendor">
                  <i class="ki-duotone ki-pencil fs-4">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-sm btn-light-danger"
                  (click)="deleteVendor(vendor)"
                  title="Delete vendor">
                  <i class="ki-duotone ki-trash fs-4">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="row" *ngIf="!isLoading && vendors.length > 0">
      <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
        <div class="dataTables_info">
          Showing {{ ((paginationInfo.currentPage - 1) * paginationInfo.perPage) + 1 }} to
          {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }}
          of {{ paginationInfo.total }} entries
        </div>
      </div>
      <div class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
        <div class="dataTables_paginate">
          <ul class="pagination">
            <!-- Previous Button -->
            <li class="page-item" [class.disabled]="paginationInfo.currentPage === 1">
              <a class="page-link" (click)="onPageChange(paginationInfo.currentPage - 1)"
                 [class.disabled]="paginationInfo.currentPage === 1">
                <i class="previous"></i>
              </a>
            </li>

            <!-- Page Numbers -->
            <li class="page-item"
                *ngFor="let page of [].constructor(paginationInfo.lastPage); let i = index"
                [class.active]="(i + 1) === paginationInfo.currentPage">
              <a class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
            </li>

            <!-- Next Button -->
            <li class="page-item" [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
              <a class="page-link" (click)="onPageChange(paginationInfo.currentPage + 1)"
                 [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
